import React, { FC, ReactNode } from "react";
import { Permission } from "common/build/prisma/client";
import { useAuth } from "../../contexts/auth.context";

export const HasPermission: FC<{ permission: Permission; children?: ReactNode }> = ({ permission, children }) => (
    <>{useAuth().hasPermission(permission) ? children : null}</>
);
